<div class="td-wb-split-buttons">
  <div class="td-wb-split-buttons__list"
       role="group"
       [attr.aria-label]="ariaLabel()"
       [attr.aria-labelledby]="ariaLabelledBy()">
    <ng-content />
  </div>
</div>
